// @flow

import * as React from 'react';
import ReactDOM from 'react-dom';
import { I18nProvider } from '@insolus/react-i18n';
import I18n from '@insolus/i18n';
import globalSetup from 'config/setup';

export type ElementsMap = {
    [element: string]: {|
        permanent: boolean,
        component: React$ComponentType<*>
    |}
};

export type ThemeBootstrap = () => ElementsMap;

export default function staticBootstrap(themeBootstrap: ThemeBootstrap) {
    globalSetup();

    const Components = themeBootstrap();

    document.addEventListener('turbolinks:load', () => {
        Object.keys(Components).forEach((elementId: string) => {
            const { permanent, component: Component } = Components[elementId];
            if (permanent) {
                return;
            }

            const $$element = document.getElementById(elementId);
            if (!$$element) {
                return;
            }

            ReactDOM.render(
                <I18nProvider i18n={I18n}><Component /></I18nProvider>,
                $$element
            );
        });
    });

    Object.keys(Components).forEach((elementId: string) => {
        const $$element = document.getElementById(elementId);
        if (!$$element) {
            return;
        }

        const { component: Component } = Components[elementId];
        ReactDOM.render(
            <I18nProvider i18n={I18n}><Component /></I18nProvider>,
            $$element
        );
    });
}
